module.exports = __webpack_public_path__ + "static/media/favicon02.12571abf.webp";